/* Worx DTF — Theme JavaScript
   Global interactions: nav, scroll reveal, FAQs, mobile menu, cart.
   ============================================================== */

(function() {
  'use strict';

  /* ---------- SCROLL REVEAL ---------- */
  const revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.reveal').forEach(function(el) {
    revealObserver.observe(el);
  });

  /* ---------- FAQ ACCORDIONS ---------- */
  document.querySelectorAll('.faq-item').forEach(function(item) {
    item.addEventListener('click', function() {
      item.classList.toggle('open');
    });
  });

  /* ---------- MOBILE MENU TOGGLE ---------- */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const header = document.querySelector('.site-header');
  if (menuToggle && header) {
    menuToggle.addEventListener('click', function() {
      header.classList.toggle('mobile-menu-open');
    });
  }

  /* ---------- DARK NAV ON DARK HERO ---------- */
  // Pages with a dark hero add `.has-dark-hero` to body — the nav matches.
  if (document.body.classList.contains('has-dark-hero')) {
    const heroEl = document.querySelector('[data-dark-hero]');
    if (heroEl && header) {
      const heroObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            header.classList.add('is-dark');
          } else {
            header.classList.remove('is-dark');
          }
        });
      }, { threshold: 0.3 });
      heroObserver.observe(heroEl);
    }
  }

  /* ---------- HEADER SHADOW ON SCROLL ---------- */
  let lastScroll = 0;
  window.addEventListener('scroll', function() {
    if (!header) return;
    const current = window.pageYOffset;
    if (current > 20) {
      header.style.boxShadow = '0 1px 0 rgba(0,0,0,0.05)';
    } else {
      header.style.boxShadow = 'none';
    }
    lastScroll = current;
  });

  /* ---------- QUANTITY CONTROLS ---------- */
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const input = btn.parentElement.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'increase') val++;
      else if (val > 1) val--;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- NEWSLETTER & EMAIL CAPTURE FORMS ---------- */
  // Light enhancement — Shopify handles actual submission.
  document.querySelectorAll('form[data-newsletter-form]').forEach(function(form) {
    form.addEventListener('submit', function() {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Subscribing...';
      }
    });
  });

  /* ---------- COUNTDOWN TIMER (Club Inkesh) ---------- */
  const countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    const targetDate = new Date(countdownEl.dataset.countdown).getTime();
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        countdownEl.innerHTML = '<div class="countdown-launched">Launched!</div>';
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      const setDigit = function(sel, val) {
        const el = countdownEl.querySelector(sel);
        if (el) el.textContent = String(val).padStart(2, '0');
      };
      setDigit('[data-days]', days);
      setDigit('[data-hours]', hours);
      setDigit('[data-minutes]', minutes);
      setDigit('[data-seconds]', seconds);
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ---------- FILTER PILLS (collection page) ---------- */
  document.querySelectorAll('[data-filter-pills]').forEach(function(group) {
    group.querySelectorAll('.filter-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        group.querySelectorAll('.filter-pill').forEach(function(p) {
          p.classList.remove('active');
        });
        pill.classList.add('active');
        const tag = pill.dataset.tag;
        if (tag) {
          window.location.href = pill.dataset.url || ('?filter=' + encodeURIComponent(tag));
        }
      });
    });
  });

  /* ---------- SIZE/VARIANT SELECTOR ---------- */
  document.querySelectorAll('[data-variant-selector]').forEach(function(group) {
    group.querySelectorAll('.size-option, .variant-option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        group.querySelectorAll('.size-option, .variant-option').forEach(function(o) {
          o.classList.remove('selected');
        });
        opt.classList.add('selected');
        const variantId = opt.dataset.variantId;
        if (variantId) {
          const hidden = document.querySelector('input[name="id"]');
          if (hidden) hidden.value = variantId;
          const priceEl = document.querySelector('[data-variant-price]');
          if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        }
      });
    });
  });

  /* ---------- AJAX CART ADD (Shopify) ---------- */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      // Let Shopify handle it natively if no AJAX class
      if (!form.classList.contains('use-ajax')) return;
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (btn) {
          btn.textContent = '✓ Added to Cart';
          btn.style.background = 'var(--color-success)';
          setTimeout(function() {
            btn.textContent = btn.dataset.originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        }
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) cartCount.textContent = cart.item_count;
      })
      .catch(function(err) {
        console.error('Cart add error:', err);
        if (btn) {
          btn.textContent = btn.dataset.originalText;
          btn.disabled = false;
        }
      });
    });
  });

})();
